document.addEventListener('click', function(e) {
  const btn = e.target.closest('.show-more-5-btn');
  if (!btn) return;
  var list = btn.closest('.spf-product__swatchs');
  list.classList.add('show-more-5');
  btn.setAttribute('aria-expanded', 'true');
  btn.style.display = 'none';
  var firstMore = list.querySelector('.more-5');
  if (firstMore) firstMore.focus();
});
document.addEventListener('click', function (e) {
  var swatch = e.target.closest('button.spf-product__swatch');
  if (!swatch) return;
  requestAnimationFrame(function () {
    swatch.parentElement.querySelectorAll('button.spf-product__swatch').forEach(function (b) {
      b.setAttribute('aria-pressed', b.classList.contains('is-selected') ? 'true' : 'false');
    });
  });
});
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.pc-swatches__more');
  if (!btn) return;
  e.preventDefault();
  var fs = btn.closest('.pc-swatches');
  if (!fs) return;
  var expanded = fs.classList.toggle('is-expanded');
  btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
});
/* SPF: kolejność kart — shuffle / sort po variant ID (wybrane kolekcje) / brak przy sortowaniu klienta; z paginacją */
(function () {
  return;
  // >>> HANDLE kolekcji (z URL /collections/<handle>) sortowane po variant ID malejąco (najnowsze pierwsze) <<<
  var TARGET_COLLECTION_HANDLES = ['nowosci-damskie','new-merino-wool-arrivals','nowosci-meskie','mens-new-merino-wool-arrivals'];

  var defaultSort = null;
  function currentSort() { try { return globofilter.state.queryParams.sort_by || null; } catch (e) { return null; } }
  function capture() { if (defaultSort === null) { var s = currentSort(); if (s) defaultSort = s; } }

  function currentHandle() {
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function isTargetCollection() {
    var h = currentHandle();
    return h !== null && TARGET_COLLECTION_HANDLES.indexOf(h) !== -1;
  }
  function variantId(el) { var v = el.getAttribute('data-variant-id'); return v ? parseInt(v, 10) : 0; }

  function process() {
    capture();
    var cur = currentSort();
    var sorted = !!(cur && defaultSort && cur !== defaultSort);

    var items = document.querySelectorAll('[class*="spf-col"]');
    if (!items.length) return;

    // klient wybrał sortowanie → kolejność Globo
    if (sorted) { items.forEach(function (el) { el.style.removeProperty('order'); }); return; }

    // wybrane kolekcje → variant ID malejąco (ranking bezpieczny dla CSS order)
    if (isTargetCollection()) {
      var arr = Array.prototype.slice.call(items);
      arr.sort(function (a, b) { return variantId(b) - variantId(a); });
      arr.forEach(function (el, i) { el.style.order = i; });
      return;
    }

    // reszta → shuffle + sekwencyjne strony
    var page = 1;
    items.forEach(function (el) {
      var dp = el.getAttribute('data-page');
      if (dp) { var n = parseInt(dp, 10); if (!isNaN(n)) page = n; }
      if (el.dataset.pcOrder === undefined) { var base = parseInt(el.style.order, 10); el.dataset.pcOrder = isNaN(base) ? '0' : String(base); }
      el.style.order = (page * 1000000) + parseInt(el.dataset.pcOrder, 10);
    });
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(process, 60); }
  if (document.readyState !== 'loading') schedule(); else document.addEventListener('DOMContentLoaded', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Dostępność: przewijane opinie TrustMate osiągalne z klawiatury (WCAG 2.1.1) */
(function () {
  var attempts = 0;
  var timer = setInterval(function () {
    var texts = document.querySelectorAll('.tm-carousel__text:not([tabindex])');
    texts.forEach(function (el) {
      if (el.scrollHeight > el.clientHeight) el.tabIndex = 0;
    });
    if (++attempts >= 10 || (texts.length === 0 && document.querySelector('.tm-carousel__text'))) clearInterval(timer);
  }, 1000);
})();

/* Promocje z terminem (data-promo-until, epoch): po terminie zdejmij notkę i przekreślenie, także na stronach z pamięci podręcznej */
(function () {
  document.querySelectorAll('[data-promo-until]').forEach(function (note) {
    if (Date.now() / 1000 <= Number(note.getAttribute('data-promo-until'))) return;
    var price = note.closest('.kopyto-promo-price');
    if (price) price.classList.remove('kopyto-promo-price');
    note.remove();
  });
})();
/* Program lojalnościowy: popup dołączenia (linki #dolacz, powrót z logowania ?dolacz=1, powrót po wysyłce customer_posted=true), zdarzenia analityczne */
(function () {
  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent('kopyto:loyalty', { detail: Object.assign({ event: name }, detail) }));
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, detail));
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, detail);
    }
  }

  var params = new URLSearchParams(location.search);

  var modal = document.getElementById('kopyto-loyalty-join');
  if (!modal) return;
  var loggedIn = modal.dataset.state !== 'guest';

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href$="#dolacz"]');
    if (!link) return;
    e.preventDefault();
    emit('loyalty_join_click', { logged_in: loggedIn });
    modal.show();
  });

  // formularz wysyła się natywnie (skrypt hCaptcha Shopify przechwytuje submit); po powrocie z ?customer_posted=true popup pokazuje stan sukcesu
  var posted = params.get('customer_posted') === 'true' && location.hash === '#kopyto-loyalty-form';
  if (posted) {
    emit('loyalty_join_success', { logged_in: true });
    history.replaceState(null, '', location.pathname);
  }
  if (posted || params.get('dolacz') === '1' || location.hash === '#dolacz' || modal.querySelector('[data-loyalty-error]')) {
    customElements.whenDefined('x-modal').then(function () { modal.show(); });
  }
})();
/* Program lojalnościowy: punkty za produkt pod przyciskami zakupu (snippets/kopyto-loyalty-points): 1 pkt za każde rozpoczęte 10 zł ceny PLN; poza PLN ceny z kopyto.com; aktualizacja przy zmianie wariantu */
(function () {
  var plnPrices = {};
  var plural = null;
  try { plural = new Intl.PluralRules(document.documentElement.lang || 'pl'); } catch (e) {}

  function render(el, pricePln) {
    if (!(pricePln > 0)) { el.hidden = true; return; }
    var points = Math.ceil(pricePln / 1000);
    var form = plural ? plural.select(points) : 'other';
    var template = el.getAttribute('data-' + form) || el.getAttribute('data-many');
    el.querySelector('[data-kopyto-loyalty-points-value]').textContent = template.replace(/\d+/, points);
    el.hidden = false;
  }

  // Ceny PLN: produkt z polskiej wersji sklepu (link hreflang="pl" ma polski uchwyt; przetłumaczone uchwyty EN/DE nie istnieją na kopyto.com)
  function plnUrl(el) {
    var alternate = document.querySelector('link[rel="alternate"][hreflang="pl"]');
    var url = new URL(alternate ? alternate.href : 'https://kopyto.com/products/' + el.dataset.handle);
    url.search = ''; url.hash = ''; url.pathname += '.js';
    return url.href;
  }

  function update(el, variantId, price) {
    if (el.dataset.currency === 'PLN') { render(el, price); return; }
    var url = plnUrl(el);
    plnPrices[url] = plnPrices[url] || fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (p) { var map = {}; p.variants.forEach(function (v) { map[v.id] = v.price; }); return map; });
    plnPrices[url].then(function (map) { render(el, map[variantId]); }).catch(function () { el.hidden = true; });
  }

  document.querySelectorAll('[data-kopyto-loyalty-points]').forEach(function (el) {
    if (el.dataset.currency !== 'PLN') update(el, el.dataset.variant);
  });

  // e.detail.formId to w Prestige pole <input name="id"> (przesłania właściwość form.id), więc id formularza bierzemy z atrybutu
  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    var formId = e.target && e.target.getAttribute ? e.target.getAttribute('id') : null;
    if (!variant || !formId) return;
    document.querySelectorAll('[data-kopyto-loyalty-points][data-form="' + formId + '"]').forEach(function (el) {
      update(el, variant.id, variant.price);
    });
  });
})();

(function () {
  const SECTION_ID =
    'shopify-section-template--29888517865807__rich_text_JdiNDx';

  const SHEEP_URL =
    'https://cdn.shopify.com/s/files/1/0982/8135/7647/files/duza-owca.png?v=1793187728';

  function initKopytoSheep() {

    const section = document.getElementById(SECTION_ID);

    if (!section) return;



    section.querySelectorAll('.kopyto-sheep-layer').forEach(function(layer) {
      layer.remove();
    });



    const layer = document.createElement('div');

    layer.className = 'kopyto-sheep-layer';

    layer.setAttribute('aria-hidden', 'true');



    for (let i = 1; i <= 2; i++) {

      const img = document.createElement('img');

      img.src = SHEEP_URL;

      img.className = 'kopyto-sheep kopyto-sheep--' + i;

      img.alt = '';

      img.loading = 'eager';

      img.decoding = 'async';

      layer.appendChild(img);
    }

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    const canAnimate =
      !reducedMotion &&
      'IntersectionObserver' in window;

    if (canAnimate) {
      layer.classList.add('is-waiting');
    }

    section.appendChild(layer);

    if (!canAnimate) return;

    const images = Array.from(layer.querySelectorAll('img'));

    const imagesReady = Promise.all(
      images.map(function(img) {

        if (img.complete) return Promise.resolve();

        return new Promise(function(resolve) {

          img.addEventListener('load', resolve, { once: true });

          img.addEventListener('error', resolve, { once: true });

        });
      })
    );

    const observer = new IntersectionObserver(
      function(entries) {

        entries.forEach(function(entry) {

          if (!entry.isIntersecting) return;

          observer.unobserve(section);

          imagesReady.then(function() {

            layer.classList.remove('is-waiting');

            layer.classList.add('is-visible');

          });

        });
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
  }

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initKopytoSheep,
      { once: true }
    );

  } else {

    initKopytoSheep();

  }

  if (!window.kopytoSheepSectionListenerAdded) {

    document.addEventListener(
      'shopify:section:load',
      initKopytoSheep
    );

    window.kopytoSheepSectionListenerAdded = true;
  }

})();
